module.exports = __webpack_public_path__ + "static/media/signage-indoor-img38.977d15ef.jpg";